import React from 'react';
import AddOnCard from './AddOnCard';

type KentikProtectCardProps = {
  kentikEdition: string;
};
const KentikProtectCard = ({ kentikEdition }: KentikProtectCardProps) => {
  const hasPremierPlan = kentikEdition === 'premier';
  const title = hasPremierPlan ? 'Kentik Protect Advanced' : 'Kentik Protect';
  const description = hasPremierPlan ? 'PROTECT-ADV' : 'PROTECT';

  return (
    <AddOnCard
      title={title}
      description={description}
      extensions={[
        {
          key: 'Radware & A10 Mitigation Integration',
          value: hasPremierPlan ? 'Enabled' : 'Unavailable'
        },
        {
          key: 'Cloudflare Magic Transit Mitigation',
          value: hasPremierPlan ? 'Enabled' : 'Unavailable'
        },
        {
          key: 'Mitigation Integration API',
          value: hasPremierPlan ? 'Enabled' : 'Unavailable'
        },
        {
          key: 'Threat Analytics',
          value: hasPremierPlan ? 'Enabled' : 'Unavailable'
        },
        {
          key: 'Botnet Analytics',
          value: hasPremierPlan ? 'Enabled' : 'Unavailable'
        }
      ]}
    />
  );
};

export default KentikProtectCard;
